import React from 'react';

import EventLink from './EventLink'
import EventMetadata from './EventMetadata'

import { timeframeToLocalizedString, kindToLocalizedString } from "../helpers";

export default ({event, ...props}) =>
    <li {...props}>
        <EventLink event={event}>
            <span className="kind">
                <b>{event.venue !== undefined && event.venue.location.city.name}</b>{kindToLocalizedString(event.kind)}
            </span>
            <span className="timeframe" dangerouslySetInnerHTML={{ __html: timeframeToLocalizedString(event.timeframe) }} />
            <h4>{event.title}</h4>
        </EventLink>
    </li>;


// WEBPACK FOOTER //
// ./src/modules/Events/elements/EventListItem.js